import { SvgIcon, SvgIconProps } from '@mui/material'

export function DeleteIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <g clipPath="url(#clip0_15108_2542)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 3.33331C2.5 3.05717 2.72386 2.83331 3 2.83331H13C13.2761 2.83331 13.5 3.05717 13.5 3.33331V14.6666C13.5 14.9428 13.2761 15.1666 13 15.1666H3C2.72386 15.1666 2.5 14.9428 2.5 14.6666V3.33331ZM3.5 3.83331V14.1666H12.5V3.83331H3.5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.6665 6.16669C6.94265 6.16669 7.1665 6.39054 7.1665 6.66669V11C7.1665 11.2762 6.94265 11.5 6.6665 11.5C6.39036 11.5 6.1665 11.2762 6.1665 11V6.66669C6.1665 6.39054 6.39036 6.16669 6.6665 6.16669Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.3335 6.16669C9.60964 6.16669 9.8335 6.39054 9.8335 6.66669V11C9.8335 11.2762 9.60964 11.5 9.3335 11.5C9.05735 11.5 8.8335 11.2762 8.8335 11V6.66669C8.8335 6.39054 9.05735 6.16669 9.3335 6.16669Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.833496 3.33331C0.833496 3.05717 1.05735 2.83331 1.3335 2.83331H14.6668C14.943 2.83331 15.1668 3.05717 15.1668 3.33331C15.1668 3.60946 14.943 3.83331 14.6668 3.83331H1.3335C1.05735 3.83331 0.833496 3.60946 0.833496 3.33331Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.99138 1.09297C6.07915 0.932852 6.24723 0.833313 6.42983 0.833313H9.59253C9.77665 0.833313 9.94588 0.934507 10.033 1.09671L11.1073 3.09671C11.1905 3.25167 11.1862 3.43896 11.096 3.58992C11.0057 3.74089 10.8427 3.83331 10.6668 3.83331H5.3335C5.15684 3.83331 4.9933 3.7401 4.90328 3.5881C4.81326 3.4361 4.81013 3.24788 4.89505 3.09297L5.99138 1.09297ZM6.72594 1.83331L6.17777 2.83331H9.83069L9.29354 1.83331H6.72594Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_15108_2542">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export default DeleteIcon
